import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { switchMap, catchError, of, map } from 'rxjs';
import * as WeblinksActions from './weblinks.actions';
import { WeblinksService } from '../service/weblinks.service';

@Injectable()
export class WeblinksEffects {
  private actions$ = inject(Actions);
  private weblinksService = inject(WeblinksService);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WeblinksActions.initWeblinks),
      switchMap((action) =>
        this.weblinksService.performPostRequest(action.language).pipe(
          map((response) => WeblinksActions.loadWeblinksSuccess({ weblinks: response.weblinks })),
          catchError((error) => {
            console.error('Error loading weblinks', error);
            return of(WeblinksActions.loadWeblinksFailure({ error: error.message }));
          })
        )
      )
    )
  );
}
